<template>
    <div class="section-team-node">
        <TreeNode 
            @handleExpand="handleExpand"
            @handleChecked="handleChecked"
            :showExpand="withMembers ? !!data.count : false"
            :showExpandIcon="withMembers ? !!data.count : false"
            :showChecked="withMembers ? !!data.count : true"
            :loading="data.loading"
            :expand="data.expand"
            :checked="checked">
            <template slot="content">{{data.teamName}}</template>
            <template 
                slot="children" 
                v-if="data.children">
                <div v-for="(item, index) in data.children" :key="index">
                    <MemberNode 
                        :data="item"
                        :parent="data"
                        @handleChecked="handleChecked" />
                </div>
            </template>
        </TreeNode>
    </div>
</template>
<script>
    /**
     * 内部群节点
     *  */
    import MemberNode from './section-member-node'
    import node from '../mixins/node'
    export default {
        name: 'GroupNode',
        inject: ['root'],
        mixins: [node],
        props: {
            data: {
                type: Object,
                default () {
                    return {}
                }
            },
            withMembers: {
                type: Boolean
            }
        },
        computed: {
            checked() {
                if(this.withMembers) {
                    const even = this.data.children.every(item => {
                        return item.checked
                    })
                    return this.data.children.length ? even : false
                }
                const data = this.root.selected.team[this.data.id] || null
                return !!data
            }
        },
        components: {
            MemberNode
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/business/select-member/section/section-team-node.vue